import { HeartHandshake } from "lucide-react";
import { BigHeart } from "./Bits";
import { scrollToSupport } from "./content";

const NODES = [[12, 22], [28, 12], [46, 26], [64, 10], [82, 24], [90, 52], [74, 70], [56, 84], [36, 74], [16, 60], [8, 40]];

function Network() {
  return (
    <svg viewBox="0 0 100 100" preserveAspectRatio="none" className="absolute inset-0 w-full h-full opacity-[.22] pointer-events-none" aria-hidden>
      {NODES.map(([x, y], i) => { const [x2, y2] = NODES[(i + 1) % NODES.length]; const [x3, y3] = NODES[(i + 4) % NODES.length]; return (
        <g key={i}><line x1={x} y1={y} x2={x2} y2={y2} stroke="#fff" strokeWidth=".25" /><line x1={x} y1={y} x2={x3} y2={y3} stroke="#fff" strokeWidth=".15" strokeDasharray="1 1.5" /><circle cx={x} cy={y} r="1.1" fill="#fff" className="cs-node" style={{ animationDelay: `${i * 260}ms` }} /></g>
      ); })}
    </svg>
  );
}

export function SupportHero() {
  return (
    <section className="relative overflow-hidden rounded-[2rem] premium-hero text-white px-6 pt-10 pb-9 sm:px-12 sm:pt-14 sm:pb-12" data-testid="cs-hero">
      <Network />
      <span className="absolute -top-24 -right-16 w-72 h-72 rounded-full bg-white/10 blur-3xl" aria-hidden />
      <span className="absolute -bottom-28 -left-20 w-80 h-80 rounded-full bg-[#9d1446]/40 blur-3xl" aria-hidden />
      <div className="relative grid lg:grid-cols-[1.25fr_1fr] gap-8 items-center">
        <div className="order-2 lg:order-1 cs-hero-in">
          <p className="inline-flex items-center gap-2 h-8 px-3.5 rounded-full bg-white/15 ring-1 ring-white/30 backdrop-blur-md text-[11px] font-extrabold uppercase tracking-[0.2em]" data-testid="cs-hero-eyebrow">❤️ Gemeinsam mehr erreichen</p>
          <p className="mt-3 text-sm sm:text-base font-semibold text-white/85">Unsere Community. Unsere Zukunft. Gemeinsam mit euch.</p>
          <h1 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight leading-[1.02]" data-testid="cs-hero-title">❤️ Gemeinsam können wir Großes schaffen!</h1>
          <p className="mt-4 max-w-xl text-base sm:text-lg text-white/90 leading-relaxed">„Was als kleine Idee begann, ist durch euch zu einer lebendigen Community geworden. Jetzt möchten wir gemeinsam mit euch die Zukunft gestalten.“</p>
          <button onClick={scrollToSupport} data-testid="cs-hero-cta"
            className="mt-7 h-14 px-7 rounded-full bg-white text-[#b3164f] font-display text-base font-black tracking-wide inline-flex items-center gap-2.5 shadow-[0_14px_30px_-10px_rgba(0,0,0,.35)] hover:-translate-y-0.5 hover:shadow-[0_20px_40px_-12px_rgba(0,0,0,.4)] active:scale-[.98] transition-[transform,box-shadow] focus:outline-none focus-visible:ring-4 focus-visible:ring-white/60">
            <HeartHandshake className="w-5 h-5" /> ❤️ Unsere Community unterstützen
          </button>
          <p className="mt-3 text-xs text-white/75">Freiwillig · Jeder Beitrag hilft · Die Community bleibt für alle kostenlos</p>
        </div>
        <div className="order-1 lg:order-2"><BigHeart size="w-32 h-32 sm:w-44 sm:h-44 lg:w-56 lg:h-56" testId="cs-hero-heart" /></div>
      </div>
    </section>
  );
}
